import styles from "./tree-select.module.css";

import { TreeItem } from "@mui/x-tree-view/TreeItem";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { useEffect, useRef, useState } from "react";
import { Button } from "@mui/material";

export interface TreeSelectProps {
    items: TreeNodeItem[];
    displayedText: string;
    selectedItems?: string[];
    onToggleChange(id: string, isSelected: boolean): void;
    onSelectClick?(): void;
    defaultExpandedIds?: string[];
    disabled?: boolean;
}

export interface TreeNodeItem {
    id: number;
    name: string;
    children: TreeNodeItem[] | null;
    path?: string;
    hasTelecareCapability?: boolean;
}

function TreeSelect(props: TreeSelectProps) {
    const {
        items,
        selectedItems,
        onToggleChange,
        onSelectClick,
        defaultExpandedIds,
        disabled,
    } = props;

    const [open, setOpen] = useState<boolean>(false);
    const dropdownRef = useRef<any>(null);

    useEffect(() => {
        document.addEventListener("mousedown", closeDropdown);

        return () => {
            document.removeEventListener("mousedown", closeDropdown);
        };
    }, []);

    const closeDropdown = (event: any) => {
        if (dropdownRef.current)
            if (!dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
    };

    const drawNode = (node: any) => {
        return (
            <TreeItem itemId={node.id} label={node.name}>
                {node.children &&
                    node.children.map((child: any) => {
                        return drawNode(child);
                    })}
            </TreeItem>
        );
    };

    const ButtonContent = () => {
        return (
            <div className={styles["button-content"]}>
                <div className={styles["location-text"]}>{"Location"}</div>
                <div className={styles["selected-location-text"]}>
                    {props.displayedText}
                </div>
            </div>
        );
    };

    const handleSelectClick = () => {
        setOpen(false);
        onSelectClick!();
    };

    const render = () => {
        return (
            <>
                <Button
                    disabled={disabled}
                    variant="outlined"
                    onClick={() => {
                        if (!disabled) setOpen(!open);
                    }}
                >
                    <ButtonContent />
                </Button>
                <div
                    className={styles["dropdown-tree-container"]}
                    ref={dropdownRef}
                    style={
                        open === false
                            ? { display: "none" }
                            : { display: "block" }
                    }
                >
                    <div className={styles["tree-container"]}>
                        <SimpleTreeView
                            multiSelect
                            checkboxSelection
                            defaultExpandedItems={defaultExpandedIds}
                            selectedItems={selectedItems}
                            onItemSelectionToggle={(_event, id, isSelected) => {
                                onToggleChange(id, isSelected);
                            }}
                        >
                            {items &&
                                items.map((node) => {
                                    return drawNode(node);
                                })}
                        </SimpleTreeView>
                    </div>

                    <div className={styles["select-button-container"]}>
                        <Button
                            onClick={() => {
                                handleSelectClick();
                            }}
                            variant="contained"
                        >
                            Select
                        </Button>
                    </div>
                </div>
            </>
        );
    };

    return render();
}

export default TreeSelect;
